<template>
  <div class="goldenFall">
    <div class="content">
      <img class="couponList" :src="imgUrl + 'APP_RES/home/htmlImgs/goldenFall.png'" alt="大方租车 元旦活动"/>
      <div class="couponText">
        <h5>使用规则</h5>
        <div class="item">
          <span></span>
          <p>进入支付宝生活号“领券中心”即可领取“租2天减50元”，“租4天减120元”和“租7天减210元”抵现券。</p>
        </div>
        <div class="item">
          <span></span>
          <p>订单连续租满2天，用券立减50元；连续租满4天，用券立减120元；连续组满7天，用券立减210天。优惠金额为车辆日租金，其他消费正常收取。</p>
        </div>
        <div class="item">
          <span></span>
          <p>本活动不与其他优惠同享。</p>
        </div>
      </div>
      <div class="couponBtn" @click="getDrawCoupon">立即领取</div>
    </div>
  </div>
</template>

<script>
import { orderSource, imgUrl, apiMode } from "@/utils/env";
import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
export default {
  name: 'goldenFall',
  data(){
    return {
      imgUrl: imgUrl,
      couponList: []
    }
  },
  created () {
    this.initData();
  },
  mounted () {},
  methods: {
    initData () {
      if( apiMode=='dev' ){
        this.couponList = [
          { name: "咯咯哒 - 108券", OfferID: 373 },
          { name: "过过过 - 288券", OfferID: 374 },
        ]
      }
      if( apiMode=='test' ){}
      if( apiMode=='build' ){
        this.couponList = [
          { name: "连续租满2天立减50元", OfferID: 164 },
          { name: "连续租满4天立减120元", OfferID: 165 },
          { name: "连续租满7天立减210元", OfferID: 166 }
        ]
      }
      console.log(this.couponList)
    },
    async getDrawCoupon () {
      let hasConRes = await getConsumerCoupons({
        data: {
          bizType: 1,
          loadAllCoupon: false,
          isGetExpired: true
        }
      });
      if( hasConRes.Code==100 ){
        if( this.couponList.length>=hasConRes.Data.length ){
          for( let i=0; i<this.couponList.length; i++ ){
            for( let j=0; j<hasConRes.Data.length; j++ ){
              if( this.couponList[i].OfferID==hasConRes.Data[j].OfferID ){
                this.couponList.splice(i, 1);
              }
            }
          }
        } else {
          for( let i=0; i<hasConRes.Data.length; i++ ){
            for( let j=0; j<this.couponList.length; j++ ){
              if( this.couponList[j].OfferID==hasConRes.Data[i].OfferID ){
                this.couponList.splice(j, 1);
              }
            }
          }
        }
        if( !this.couponList.length ){
          this.flexible.showToast({
            content: "已领取过啦，去租车吧！",
          });
          return;
        }
        for( let i=0; i<this.couponList.length; i++ ){
          let res = await DrawCoupon({
            data: { offerId: this.couponList[i].OfferID },
            isShow: false
          });
          if( res.Code==100 ){
            this.flexible.showToast({
              type: 'success',
              content: "领取成功，去租车吧！",
            });
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.goldenFall {
  width: 100%;
  min-height: 100%;
  position: absolute;
  padding-top: 470px;
  background: #EACA97 url("http://cms.dafang24.com/APP_RES/home/htmlImgs/goldenFallBg.png")  no-repeat center top;
  background-size: 100% auto;
  box-sizing: border-box;
  .content {
    width: 570px;
    margin: 0 auto;
    img.couponList {
      width: 100%;
    }
    .couponText {
      margin-top: 60px;
      h5 {
        width: 100%;
        text-align: center;
        margin-bottom: 40px;
      }
      .item {
        display: flex;
        align-items: flex-start;
        margin-top: 6px;
        span {
          flex: 0 0 14px;
          height: 14px;
          background-color: #FFA843;
          color: #FFA843;
          border-radius: 50%;position: relative;
          top: 8px;
          margin-right: 10px;
        }
        p {
          font-size: 24px;
          line-height: 32px;

        }
      }
    }
    .couponBtn {
      width: 412px;
      height: 92px;
      margin: 60px auto 0;
      text-align: center;
      line-height: 92px;
      font-size: 32px;
      color: #fff;
      border-radius: 46px;
      background-image: linear-gradient(to right, #FFCA48 , #FF9A3E);
      background-color: #FFB844;
    }
  }
}
</style>